import FussionLoader from 'components/Legacy/FussionLoader'
import React from 'react'
import styled from 'styled-components'
import { color, theme } from 'utils'

const Loader = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: ${theme('inputBorderRadius')};
`

const OverlayLoaderWrapper = styled(Loader)`
  background: ${color('blackAlpha25')};
`

export const OverlayLoader = () => (
  <OverlayLoaderWrapper>
    <FussionLoader />
  </OverlayLoaderWrapper>
)

export const CoverLoader = () => (
  <Loader>
    <FussionLoader />
  </Loader>
)
